import React from "react";
import { GetImage } from "../../../../../../components/helpers/GetImage";

const PictureTab = ({ data, handlePreview }) => {
  return (
    <div className="detail-bold-text">
      <div
        className="picture-container d-flex flex-column"
        style={{ gap: "10px" }}
      >
        <div className="picture-label-style">Foto Fisik Barang</div>
        <div className="d-flex flex-row" style={{ gap: "10px" }}>
          {data?.productPictures?.length > 0 ? (
            data?.productPictures?.map((pic) => {
              return (
                <div
                  onClick={() =>
                    handlePreview(`gadai-product-picture/${pic?.id}/picture`)
                  }
                >
                  <GetImage
                    url={`gadai-product-picture/${pic?.id}/picture`}
                    width={140}
                    height={140}
                    className="picture-style"
                  />
                </div>
              );
            })
          ) : (
            <div style={{ fontWeight: "normal" }}>Tidak ada foto</div>
          )}
        </div>
      </div>
      <div
        className="picture-container d-flex flex-column"
        style={{ gap: "10px" }}
      >
        <div className="picture-label-style">Foto Simpan Barang</div>
        <div
          className="d-flex flex-column"
          style={{ gap: "0", color: "#A6A6A6" }}
        >
          <div>
            Disimpan: {data?.storagePictures?.officerName || "-"},{" "}
            {data?.storagePictures?.storedDate || "-"}
          </div>
          <div>Catatan: {data?.notes || "-"}</div>
        </div>
        <div className="d-flex flex-row" style={{ gap: "10px" }}>
          {data?.storagePictures?.pictures?.length > 0 ? (
            data?.storagePictures?.pictures?.map((pic) => {
              return (
                <div
                  onClick={() =>
                    handlePreview(`storage-product-picture/${pic.id}/picture`)
                  }
                >
                  <GetImage
                    url={`storage-product-picture/${pic.id}/picture`}
                    width={140}
                    height={140}
                    className="picture-style"
                  />
                </div>
              );
            })
          ) : (
            <div style={{ fontWeight: "normal" }}>Tidak ada foto</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PictureTab;
